import { CIcon } from '~/icons/types'

export const ciCall: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.5 22.5h-2.25A15.77 15.77 0 0 1 1.5 6.75V4.5a3 3 0 0 1 3-3h1.37a1.87 1.87 0 0 1 1.82 1.42L8.8 7.34a1.88 1.88 0 0 1-.7 2l-1.29 1a.32.32 0 0 0-.13.35 11.26 11.26 0 0 0 6.7 6.7.31.31 0 0 0 .35-.13l1-1.29a1.88 1.88 0 0 1 2-.7l4.42 1.11a1.87 1.87 0 0 1 1.42 1.82v1.3a3 3 0 0 1-3.07 3ZM4.5 3A1.5 1.5 0 0 0 3 4.5v2.25A14.26 14.26 0 0 0 17.25 21h2.25a1.5 1.5 0 0 0 1.5-1.5v-1.37a.38.38 0 0 0-.28-.36l-4.43-1.11a.37.37 0 0 0-.39.14l-1 1.29a1.78 1.78 0 0 1-2.07.63 12.73 12.73 0 0 1-7.59-7.58 1.82 1.82 0 0 1 .64-2.07l1.29-1a.37.37 0 0 0 .14-.39l-1.07-4.4A.4.4 0 0 0 5.87 3H4.5Z'
    }
  ],
  name: 'call',
  type: 'regular'
}
